import { request as __request } from '../core/request.js';
export class OffsetLinksService {
    /**
     * Get an offset link
     * @param id The offset links's unique identifier
     * @returns OffsetLink Offset link fetched successfully.
     */
    getOffsetLink(id) {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/offset-links/{id}',
            path: {
                id: id,
            },
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                404: `The offset link does not exist`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Update an offset link
     * @param id The offset links's unique identifier
     * @param requestBody
     * @returns OffsetLink The offset link updated successfully.
     */
    updateOffsetLink(id, requestBody) {
        return __request(this.client, this.config, {
            method: 'PUT',
            url: '/offset-links/{id}',
            path: {
                id: id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized. The API Key is invalid or disabled.`,
                404: `An offset link with the specified id belonging to the authenticated account has not been found.`,
                415: `The request is not an application/json encoded request`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * List offset links
     * @param limit Maximum number of resources to return, between 1 and 100.
     *
     * @param after A cursor for use in pagination.
     *
     * *after* is an object ID that defines your place in the list.
     *
     * For instance, if you make a list request and receive 100 objects, ending with *foo*, your subsequent call can include *after=foo* in order to fetch the next page of the list.
     *
     * @returns PaginatedOffsetLinks Offset links fetched successfully.
     */
    listOffsetLinks(limit = '10', after) {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/offset-links',
            query: {
                limit: limit,
                after: after,
            },
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Create an offset link
     * @param requestBody
     * @returns OffsetLink The offset link created successfully.
     */
    createOffsetLink(requestBody) {
        return __request(this.client, this.config, {
            method: 'POST',
            url: '/offset-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized. The API Key is invalid or disabled.`,
                409: `Conflict`,
                415: `The request is not an application/json encoded request`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Get offset link's analytics
     * @param id The offset links's unique identifier
     * @returns OffsetLinkAnalytics Offset link analytics fetched successfully.
     */
    getOffsetLinkAnalytics(id) {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/offset-links/{id}/analytics',
            path: {
                id: id,
            },
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                404: `The offset link does not exist`,
                429: `Rate limit exceeded`,
            },
        });
    }
}
//# sourceMappingURL=OffsetLinksService.js.map